export enum PLAYER {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=792648553
     */
    CAPTIONS = 'PLAY.CAPTIONS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=838515738
     */
    CONNECTING_ELIPSIS = 'PLAY.CONNECTING_ELIPSIS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=838516021
     */
    GOOGLE_CAST = 'PLAY.GOOGLE_CAST',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=748150567
     * */
    MAIN_TITLE = 'PLAY.VIDEO_PLAYER_MAIN_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=792646723
     */
    QUALITY = 'PLAY.QUALITY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=792651929
     */
    SPEED = 'PLAY.SPEED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=112146767
     * */
    TITLE = 'PLAY.VIDEO_PLAYER_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=273002248
     * */
    WATCH_VIDEO = 'PLAY.WATCH_VIDEO',
}
